<main class="min-h-screen w-screen bg-neutral-100">
  <crm-sidebar />
  <div class="ml-[240px]">
    <router-outlet />
  </div>
  <crm-footer />
</main>
